import DatastoreTypeHandler from './DatastoreTypeHandler'
import {
  normalizeMetadataRows,
  requiredFileRule,
  serializeMetadata,
} from './helpers'

export default class RasterDatastoreHandler extends DatastoreTypeHandler {
  emptyFileValue() {
    return []
  }

  fileRules() {
    return [requiredFileRule]
  }

  prepareFormData(data) {
    data.file = Array.isArray(data.file) ? data.file : []
    data.metadata = normalizeMetadataRows(data.metadata)
    return data
  }

  buildCreatePayload(data, context = {}) {
    const payload = super.buildCreatePayload(data, context)
    payload.file = data.file
    payload.raster_source_id = data.raster_source_id
    payload.raster_type_id = data.raster_type_id
    payload.metadata = serializeMetadata(data.metadata)
    return payload
  }

  buildUpdatePayload(data) {
    return Object.assign(super.buildUpdatePayload(data), {
      raster_source_id: data.raster_source_id,
      raster_type_id: data.raster_type_id,
      metadata: serializeMetadata(data.metadata),
    })
  }
}
